import { ApplicationRef, createComponent, EnvironmentInjector, Injectable, Type } from '@angular/core';
import { DrawerContainerComponent } from "@shared/components/drawer-container/drawer-container.component";

@Injectable({
  providedIn: 'root'
})
export class DrawerService {

  constructor(
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector

  ) {}

  public open(component: Type<any>, config?: {
    data?: any;
    title?: string;
    showActions?: boolean;
    onConfirm?: () => void;
  }) {

    const componentRef = createComponent(DrawerContainerComponent, {
      environmentInjector: this.injector
    });

    componentRef.instance.component = component;
    componentRef.instance.data = config?.data;
    componentRef.instance.title = String(config?.title);
    componentRef.instance.showActions = config?.showActions || false;


    componentRef.instance.close = () => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    };

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as any).rootNodes[0];

    document.body.appendChild(domElem);
  }
}